import { useState, useEffect } from 'react';
import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Stack,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import axios from '../../utils/axios';
// hooks
import useResponsive from '../../hooks/useResponsive';
// componenets
import Iconify from '../../components/Iconify';

const SERIES = [
  '시드', 'Pre-A', '시리즈 A', '시리즈 B', '시리즈 C', '시리즈 D', '시리즈 E', '유니콘', 'IPO'
]


export default function HideCareerDialog({ isOpen, closeDialog, career, hideCareer, unHideCareer, careerIndex }) {
  const smUp = useResponsive('up', 'sm');

  const [aliasName, setAliasName] = useState('');
  const [aliasNameError, setAliasNameError] = useState(false);

  const [size, setSize] = useState('');
  const [domain, setDomain] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [checkUnhide, setCheckUnhide] = useState(false);

  const isModify = !!career?.is_hidden_company_name

  const loadCategory = async () => {
    if (categoryOptions.length > 0) return ;
    const categoryResponse = await axios.get('api/common/categories/');
    setCategoryOptions(categoryResponse.data.map((category) => category.name));
  }

  const [typeDirect, setTypeDirect] = useState(false);

  const handlealiasName = (e) => {
    setAliasName(e.target.value);
    setAliasNameError(!e.target.value);
  };

  const setAliasNameBy = (size, domain) => {
    const bizName = size === 'IPO' ? '기업' : '스타트업';
    setAliasName(`${size} ${domain} ${bizName}`);
  }

  const handleTypeDirect = (e) => {
    setTypeDirect(e.target.checked);
    if (!e.target.checked && (size || domain)) {
      setAliasNameBy(size, domain);
    }
  };

  const handleSize = (value) => {
    setSize(value);
    setAliasNameBy(value, domain);
  }

  const handleDomain = (value) => {
    setDomain(value);
    setAliasNameBy(size, value);
  }

  const close = async () => {
    setAliasName('');
    setAliasNameError(false);

    setSize('');
    setDomain('');

    setTypeDirect(false);

    setCheckUnhide(false);

    closeDialog();
  };

  useEffect(() => {
    if (isOpen) {
      loadCategory();
      setSize(career?.selected_size || '');
      setDomain(career?.selected_domain || '');
      setAliasName(career?.alias_name || '');
      setTypeDirect(career?.is_direct_input_company_name || false);
    }
  }, [isOpen]);

  const hide = async () => {
    if (!aliasName) {
      setAliasNameError(!aliasName);
      return ;
    }

    if (aliasName.length > 30) {
      setAliasNameError(true);
      return ;
    }

    hideCareer({
      index: careerIndex,
      alias_name: aliasName,
      is_direct_input_company_name: typeDirect,
      selected_size: size,
      selected_domain: domain,
    })
    close();
  }

  const unHide = async () => {
    unHideCareer({
      index: careerIndex,
      alias_name: null,
      is_direct_input_company_name: false,
      selected_size: null,
      selected_domain: null,
    })
    close();
  }

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="sm">
      {checkUnhide && (
      <>
        <DialogContent>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
            <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 20, height: 20, color: 'error.main' }} />
            <Typography variant="subtitle2" sx={{ color: "error.main" }}>
              잠깐, 꼭 확인해주세요
            </Typography>
          </Stack>
          <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
            가리기 해제시 경력 사항에 적힌 회사로 보여져요.
          </Typography>
          <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }}>
            가리기를 해제하시겠어요?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Stack direction={{ xs: "column-reverse", sm: "row" }} sx={{ width: 1 }} spacing={2} justifyContent="flex-end">
          <Button
            onClick={() => setCheckUnhide(false)}
            size="large"
            sx={{ px: 6 }}
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={unHide}
            size="large"
            sx={{ px: 6 }}
          >
            해제
          </Button>
          </Stack>
        </DialogActions>
      </>
      )}
      {!checkUnhide && (
      <>
      <DialogTitle sx={{ mb: 1 }}>
        회사 이름 가리기
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          회사 이름을 공개하기 어려울 때는 가릴 수 있어요. <br/>
          규모와 도메인을 선택해서 회사 이름을 대체해보세요.
        </DialogContentText>
        <Stack spacing={3}>
          {!typeDirect && (
          <Stack direction={{ xs: "column", sm: "row" }} spacing={3} >
            <Stack spacing={1} sx={{ width: 1 }}>
              <Typography variant="subtitle2">
                규모 선택
              </Typography>
              <Select
                fullWidth
                value={size}
                onChange={(e) => handleSize(e.target.value)}
              >
                {SERIES.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </Select>
            </Stack>
            <Stack spacing={1} sx={{ width: 1 }}>
              <Typography variant="subtitle2">
                도메인 선택
              </Typography>
              <Select
                fullWidth
                value={domain}
                onChange={(e) => handleDomain(e.target.value)}
              >
                {categoryOptions.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}
              </Select>
            </Stack>
          </Stack>
          )}
          {typeDirect && (
          <Stack spacing={1}>
            <Stack spacing={1} sx={{ width: 1 }}>
              <Typography variant="subtitle2">
                직접 작성
              </Typography>
              <Typography variant="body2" sx={{ color: "grey.600" }}>
                규모 및 도메인 선택 외에 <b>네카라쿠배, FAANG, MAMAA, 유니콘 커머스 스타트업</b> 처럼 직접 입력할 수 있어요.<br/>
                직접 입력을 원하면 하단에 작성해주세요.
              </Typography>
            </Stack>
            <Stack spacing={1} sx={{ width: 1 }}>
              <TextField
                fullWidth
                value={aliasName}
                error={aliasNameError}
                helperText={aliasNameError ? aliasName?.length > 30 ? '30자 이하로 입력해주세요' : '대체할 이름을 입력해주세요' : ''}
                onChange={handlealiasName}
              />
            </Stack>
          </Stack>
          )}
          <Stack spacing={1} sx={{ width: 1 }}>
            <Typography variant="subtitle2">
              적용될 기업명
            </Typography>
            <Typography sx={{ color: "text.secondary" }}>
              {aliasName}
            </Typography>
          </Stack>
          <FormGroup sx={{ mb: 1, flexDirection: 'row', justifyContent: 'flex-end' }}>
            <FormControlLabel
              control={<Checkbox checked={typeDirect} onClick={handleTypeDirect} />}
              label="직접 작성할게요"
              sx={{ color: "text.secondary", '& .MuiFormControlLabel-label' : {fontWeight: 'bold' } }}
            />
          </FormGroup>
        </Stack>
      </DialogContent>
      <DialogActions>
        {isModify && (
        <LoadingButton
          sx={{ px: 4 }}
          onClick={() => setCheckUnhide(true)}
          size="large"
          color="error"
        >
          가리기 해제
        </LoadingButton>
        )}
        {!isModify && (
        <LoadingButton
          sx={{ px: 4 }}
          onClick={close}
          size="large"
        >
          취소
        </LoadingButton>
        )}
        <LoadingButton
          sx={{ px: 6 }}
          variant="contained"
          onClick={hide}
          size="large"
        >
          완료
        </LoadingButton>
      </DialogActions>
      </>
      )}
    </Dialog>
  )
}